export const GROUPBY_DATE = 'date';
export const GROUPBY_ADVISOR = 'advisor_login';
export const GROUPBY_PLAYLIST = 'playlist';
export const GROUPBY_GOODYBAG = 'goodybag'; // not used yet
export const GROUPBY_TYPES = [
  GROUPBY_DATE,
  GROUPBY_ADVISOR,
  GROUPBY_PLAYLIST,
  GROUPBY_GOODYBAG,
];
